// define a mixin object
export default {
  computed: {
    app() {
      return this.$root.$children[0];
    }
  }
};
